import React from "react";
import { Tag } from "antd";
import styles from "./VendorCard.module.css";
// import starIcon from "assets/star.png"; // Replace with your actual path
import StarRatings from "react-star-ratings";
import { useNavigate } from "react-router-dom";

const VendorCard = ({ id, image, title, rating, location, category, slug }) => {
  const formattedCategories = category;
  const navigate = useNavigate();

  console.log("category rrr", category, rating);

  return (
    <div className={styles.card} onClick={() => navigate(`/vendors/${id}`)}>
      <div className={styles.imageContainer}>
        <img src={image} alt={title} className={styles.image} />
      </div>

      <div className={styles.content}>
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
          {typeof rating === "number" && rating > 0 && (
            <div className={styles.rating}>
              <span>{Number(rating).toFixed(1)}</span>
              <StarRatings
                rating={1}
                starRatedColor="#faad14"
                numberOfStars={1}
                starDimension="16px"
                starSpacing="0px"
              />

            </div>
          )}
        </div>
        <div className={styles.locationDiv}>
          <img src="/img/packages/location_icon.svg" />
          <p className={styles.location}>{location}</p>
        </div>

        <div className={styles.tags}>
          {formattedCategories.map((cat, idx) => (
            <Tag className={styles.categoryTag} key={idx}>
              {cat?.categoryName}
            </Tag>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VendorCard;
